import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptContextSidebarModule } from "@common/shell/context-sidebar/context-sidebar.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptEntityValidatorModule } from "@common/ux/entity-validator/entity-validator.module";
import { AdaptIconModule } from "@common/ux/icon/icon.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptSeeMoreModule } from "@common/ux/see-more/see-more.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { AdaptArchitectureModule } from "@org-common/lib/architecture/architecture.module";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { TeamRolesPinPersonButtonComponent } from "@org-common/lib/team-roles/team-roles-pin-person-button/team-roles-pin-person-button.component";
import { DxCheckBoxModule, DxPopoverModule, DxScrollViewModule, DxSelectBoxModule, DxSortableModule, DxTextBoxModule, DxTreeViewModule } from "devextreme-angular";
import { CollapseDirective } from "ngx-bootstrap/collapse";
import { SortablejsModule } from "nxt-sortablejs";
import { DisplayRoleConnectionHandoverStatusComponent } from "./display-role-connection-handover-status/display-role-connection-handover-status.component";
import { EditTeamRolesDialogComponent } from "./edit-team-roles-dialog/edit-team-roles-dialog.component";
import { TeamRolesComponent } from "./team-roles/team-roles.component";
import { TeamRolesConnectionComponent } from "./team-roles-connection/team-roles-connection.component";
import { TeamRolesMeetingAgendaItemComponent } from "./team-roles-meeting-agenda-item/team-roles-meeting-agenda-item.component";
import { TeamRolesNewRoleButtonComponent } from "./team-roles-new-role-button/team-roles-new-role-button.component";
import { TeamRolesPinExistingRoleButtonComponent } from "./team-roles-pin-existing-role-button/team-roles-pin-existing-role-button.component";


@NgModule({
    imports: [
        CommonModule,
        AdaptButtonModule,
        AdaptCommonDialogModule,
        AdaptDirectorySharedModule,
        AdaptTooltipModule,
        AdaptMenuModule,
        AdaptSeeMoreModule,
        AdaptUniversalDashboardElementModule,
        DxCheckBoxModule,
        DxPopoverModule,
        DxTextBoxModule,
        SortablejsModule,
        AdaptArchitectureModule,
        AdaptEntityValidatorModule,
        AdaptIconModule,
        DxSelectBoxModule,
        DxTreeViewModule,
        AdaptContextSidebarModule,
        DxScrollViewModule,
        CollapseDirective,
        DxSortableModule,
    ],
    declarations: [
        TeamRolesComponent,
        TeamRolesConnectionComponent,
        TeamRolesMeetingAgendaItemComponent,
        EditTeamRolesDialogComponent,
        DisplayRoleConnectionHandoverStatusComponent,
        TeamRolesNewRoleButtonComponent,
        TeamRolesPinExistingRoleButtonComponent,
        TeamRolesPinPersonButtonComponent,
    ],
    exports: [
        TeamRolesComponent,
        DisplayRoleConnectionHandoverStatusComponent,
    ],
})
export class AdaptTeamRolesModule {
    // prevent being optimised by tree-shaker
    public readonly meetingAgendaItemComponents = [
        TeamRolesMeetingAgendaItemComponent,
    ];
}
